import { TbError404 } from "react-icons/tb";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col w-full items-center justify-center gap-y-6 h-[100vh] font-poppins bg-gradient-to-b from-white via-light-green-50 to-white">
      <TbError404 className="h-[100px] w-[100px] text-dark-green" />
      <h2 className="text-3xl text-dark-green font-bold">
        No se encontró la ruta
      </h2>
      <Link to="/home">
        <button
          className={` w-fit bg-light-purple-600 text-xl  flex justify-center rounded-full py-4 px-8 text-white hover:bg-dark-purple transition-all duration-100 font-bold font-poppins `}
        >
          <span className="flex flex-row items-center gap-x-2">
            <span>Ir a inicio</span>
          </span>
        </button>
      </Link>
    </div>
  );
};

export default NotFound;
